import { DicomProcessor } from '../domain/services/dicomProcessor';
import { ViewManager } from './view/ViewManager';

/**
 * Reference to {@link WebGL2RenderingContext}.\
 * This global context is used by all the components that need to access the {@link WebGL2RenderingContext WebGLContext}.\
 * This context is connected to the {@link ViewManager ViewManager}'s {@link ViewManager.canvas OffscreenCanvas}
 */
export let gl: WebGL2RenderingContext;

/**
 * Method to initialize the engine. This sets up the ViewManager and {@link WebGL2RenderingContext WebGLContext}.
 * The ViewManager gets no input surface: each viewer surface attaches its own.
 * A repeat call returns the existing ViewManager.
 */
export function initializeEngine(dp: DicomProcessor): ViewManager;

/**
 * Method to initialize the engine. This sets up the ViewManager and {@link WebGL2RenderingContext WebGLContext}.
 * @param width The initial width of the {@link ViewManager.canvas OffscreenCanvas}.
 * @param height The initial height of the {@link ViewManager.canvas OffscreenCanvas}.
 */
export function initializeEngine(
    dp: DicomProcessor,
    width: number,
    height: number
): ViewManager;

export function initializeEngine(
    dp: DicomProcessor,
    width?: number,
    height?: number
): ViewManager {
    const [viewManager, context] =
        width === undefined
            ? ViewManager.initializeViewManager(dp)
            : ViewManager.initializeViewManager(dp, width, height as number);
    gl = context;
    return viewManager;
}

// allow mocking the gl context for testing
export function setGl(glContext: WebGL2RenderingContext): void {
    gl = glContext;
}
